/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Resend_Sender_EmailInputs */

const en_admin_settings_fields_resend_sender_email = /** @type {(inputs: Admin_Settings_Fields_Resend_Sender_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sender Email`)
};

/**
* | output |
* | --- |
* | "Sender Email" |
*
* @param {Admin_Settings_Fields_Resend_Sender_EmailInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_resend_sender_email = /** @type {((inputs?: Admin_Settings_Fields_Resend_Sender_EmailInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Resend_Sender_EmailInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_resend_sender_email(inputs)
});
export { admin_settings_fields_resend_sender_email as "admin.settings.fields.resend_sender_email" }